import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useApi from "../../../CustomHooks/useApi";
import useRDService from "../../../CustomHooks/useRDService";
import $ from "jquery";


export default function SubhearnBank5Ekyc({ onBack, onSuccess }) {
  const merchantdetails = useSelector((s) => s.auth?.employeeDetails);
  const { lat, lng }    = useSelector((s) => s.location);

  const mid       = merchantdetails?.username || "";
  const latitude  = lat?.toString() || "";
  const longitude = lng?.toString() || "";

  const { captureFingerprint, loading: rdLoading } = useRDService();

  const { callApi: onboardApi }   = useApi("/aeps/subhearn/bank5/onboard-from-user", "POST");
  const { callApi: doEkycApi }    = useApi("/aeps/subhearn/bank5/doekyc",            "POST");
  const { callApi: doBioEkycApi } = useApi("/aeps/subhearn/bank5/dobioekyc",         "POST");

  const [loading,  setLoading]  = useState(false);
  const [message,  setMessage]  = useState("");
  const [editMode, setEditMode] = useState(false);

  const [showCapture,        setShowCapture]        = useState(false);
  const [biometricCompleted, setBiometricCompleted] = useState(false);

  const [biometricStatusData, setBiometricStatusData] = useState({
    status: "", action: "", kycStatus: "", message: "",
  });

  const [bioMeta, setBioMeta] = useState({ referenceKey: "", pidOptionWadh: "" });

  const [form, setForm] = useState({
    name:     merchantdetails?.name            || "",
    mobile:   merchantdetails?.mobile_number   || "",
    email:    merchantdetails?.email           || "",
    pan:      merchantdetails?.pan             || "",
    aadhaar:  merchantdetails?.aadhaar_number  || "",
    dob:      merchantdetails?.dob             || "",
    gender:   merchantdetails?.gender          || "",
    address:  merchantdetails?.address?.full   || "",
    city:     merchantdetails?.address?.city   || "",
    pincode:  merchantdetails?.address?.pincode || "",
  });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const formatDOB = (dob) => {
    if (!dob) return "";
    const d = new Date(dob);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  };

  const parsePidXml = (xml) => {
    const $xml = $(xml);
    const get  = (sel, attr) => $xml.find(sel).attr(attr) || "0";
    const infoValue = (name) =>
      $xml.find(`Info[name='${name}']`).attr("value") ||
      $xml.find(`Param[name='${name}']`).attr("value") || "0";
    return {
      dc:          get("DeviceInfo", "dc"),
      ci:          get("Skey", "ci"),
      hmac:        $xml.find("Hmac").text() || "0",
      dpId:        get("DeviceInfo", "dpId"),
      mc:          get("DeviceInfo", "mc"),
      pidDataType: get("Data", "type"),
      sessionKey:  $xml.find("Skey").text() || "0",
      mi:          get("DeviceInfo", "mi"),
      rdsId:       get("DeviceInfo", "rdsId"),
      errCode:     get("Resp", "errCode"),
      errInfo:     get("Resp", "errInfo"),
      fCount:      get("Resp", "fCount"),
      fType:       get("Resp", "fType"),
      iCount:      get("Resp", "iCount"),
      iType:       get("Resp", "iType"),
      pCount:      get("Resp", "pCount"),
      pType:       "0",
      srno:        infoValue("srno"),
      sysid:       infoValue("sysid"),
      ts:          infoValue("ts"),
      pidData:     $xml.find("Data").text() || "0",
      qScore:      get("Resp", "qScore"),
      nmPoints:    get("Resp", "nmPoints"),
      rdsVer:      get("DeviceInfo", "rdsVer"),
    };
  };

  /* ── helper: normalise doekyc / dobioekyc response ── */
  const resolveEkycAction = (res) => {
    const d      = res?.data || res;
    const action = (d?.action || "").toUpperCase();
    return { d, action };
  };

  /* ── on mount: check Bio eKYC status via doEkycApi ── */
  useEffect(() => {
    if (!mid) return;
    const getBiometricStatus = async () => {
      try {
        setLoading(true);
        const res = await doEkycApi({ mid });
        const { d, action } = resolveEkycAction(res);

        if (
          Boolean(d?.outletId) &&
          action === "ACTION-REQUIRED" &&
          (d?.kycStatus || d?.status || "").toUpperCase() === "PENDING"
        ) {
          setBioMeta({ referenceKey: d?.referenceKey || "", pidOptionWadh: d?.pidOptionWadh || "" });
          setShowCapture(true);
        } else if (action === "NO-ACTION-REQUIRED") {
          setBiometricStatusData({
            status:    d?.status    || "",
            action:    d?.action    || "",
            kycStatus: d?.kycStatus || "",
            message:   res?.message || d?.message || "",
          });
          setBiometricCompleted(true);
        } else if (d?.statuscode === "ERR" || res?.success === false) {
          setMessage(res?.message || d?.status || "Activation pending from bank. Please try again later.");
        }
      } catch { /* silent — merchant may not be onboarded yet */ }
      finally { setLoading(false); }
    };
    getBiometricStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mid]);

  /* ── "Start E-KYC" button: onboard → doekyc ── */
  const handleEkyc = async () => {
    try {
      setLoading(true);

      const body = {
        mid,
        fullName: form.name,
        mobile:   form.mobile,
        email:    form.email,
        pan:      form.pan.toUpperCase(),
        aadhaar:  form.aadhaar,
        dob:      formatDOB(form.dob),
        gender:   form.gender,
        address:  form.address,
        city:     form.city,
        pincode:  form.pincode,
        latitude,
        longitude,
      };

      const res = await onboardApi(body);

      if (res?.statuscode === "TXN" || res?.status === "SUCCESS" || res?.success === true) {

        const ekycRes           = await doEkycApi({ mid });
        const { d, action }     = resolveEkycAction(ekycRes);

        if (
          Boolean(d?.outletId) &&
          action === "ACTION-REQUIRED" &&
          (d?.kycStatus || d?.status || "").toUpperCase() === "PENDING"
        ) {
          setBioMeta({ referenceKey: d?.referenceKey || "", pidOptionWadh: d?.pidOptionWadh || "" });
          setMessage("Please capture biometric.");
          setShowCapture(true);
        } else if (action === "NO-ACTION-REQUIRED") {
          setBiometricStatusData({
            status:    d?.status    || "",
            action:    d?.action    || "",
            kycStatus: d?.kycStatus || "",
            message:   ekycRes?.message || d?.message || "",
          });
          setBiometricCompleted(true);
        } else {
          /* ERR or unknown — bank activation pending, do not show capture */
          const ekycD = ekycRes?.data || ekycRes;
          setMessage(ekycRes?.message || ekycD?.status || "Activation pending from bank. Please try again later.");
        }
        return;
      }

      setMessage(res?.message || res?.status || "E-KYC initiation failed");
    } catch {
      setMessage("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  /* ── Biometric capture: dobioekyc ── */
  const handleBiometricSubmit = async () => {
    try {
      setLoading(true);
      setMessage("");

      const pidXml  = await captureFingerprint(bioMeta.pidOptionWadh || "");
      const pidData = parsePidXml(pidXml);

      const res = await doBioEkycApi({
        mid,
        referenceKey: bioMeta.referenceKey,
        latitude,
        longitude,
        biometricData: pidData,
      });

      /* exact match (same as EkycComponent) */
      if (
        res?.statuscode === "TXN" &&
        res?.kycStatus === "SUCCESS" &&
        res?.isKycCompleted === true &&
        res?.status?.includes("Biometric KYC completed")
      ) {
        setMessage("Biometric KYC completed successfully");
        setBiometricCompleted(true);
        if (onSuccess) setTimeout(onSuccess, 1000);
        return;
      }

      /* Bank5 may return a different shape — handle generic success too */
      if (res?.statuscode === "TXN" || res?.status === "SUCCESS" || res?.success === true) {
        setMessage("Biometric eKYC completed successfully");
        setBiometricCompleted(true);
        if (onSuccess) setTimeout(onSuccess, 1000);
        return;
      }

      setMessage(res?.status || res?.message || "Biometric verification failed");
    } catch (error) {
      setMessage(error?.response?.data?.status || error?.message || "Biometric failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="overflow-hidden bg-gray-100 p-4 flex items-center">
      <div className="w-full bg-white rounded-2xl shadow-xl p-6">

        {/* Header */}
        <div className="flex justify-between items-center mb-6 border-b pb-4">
          <button onClick={onBack} className="px-4 py-2 bg-gray-100 rounded-lg">
            ← Back to AEPS
          </button>

          {!showCapture && !biometricCompleted && (
            <button
              onClick={() => setEditMode(!editMode)}
              className="px-5 py-2 bg-indigo-600 text-white rounded-lg"
            >
              {editMode ? "Save Details" : "Edit Details"}
            </button>
          )}
        </div>

        <h2 className="text-2xl font-semibold mb-6">E-KYC Verification</h2>

        {/* ── Completed (NO-ACTION-REQUIRED) ── */}
        {biometricCompleted ? (
          <div className="text-center py-10">
            <h3 className="text-2xl text-green-600 mb-6">
              ✅ {biometricStatusData.status || biometricStatusData.message || "eKYC Completed"}
            </h3>
            <div className="bg-green-50 rounded-xl p-6">
              <p><b>Action:</b> {biometricStatusData.action}</p>
              <p><b>KYC Status:</b> {biometricStatusData.kycStatus}</p>
              {biometricStatusData.message && (
                <p className="mt-2 text-gray-600">{biometricStatusData.message}</p>
              )}
            </div>
          </div>

        ) : showCapture ? (
          /* ── Biometric capture screen ── */
          <div className="text-center py-12">
            <h3 className="text-xl mb-6">Biometric Authentication Required</h3>
            <button
              onClick={handleBiometricSubmit}
              disabled={loading || rdLoading}
              className="w-full py-4 bg-green-600 text-white rounded-xl"
            >
              {loading ? "Capturing..." : "Capture Fingerprint"}
            </button>
          </div>

        ) : (
          /* ── Form ── */
          <>
            <div className="mb-6">
              <h3 className="font-semibold mb-4">Personal Details</h3>
              <div className="grid md:grid-cols-2 gap-4">
                <Input label="Full Name"  name="name"    value={form.name}    onChange={handleChange} disabled={!editMode} />
                <Input
                  label="Mobile"
                  name="mobile"
                  value={form.mobile}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    if (value.length <= 10) handleChange({ target: { name: "mobile", value } });
                  }}
                  disabled={!editMode}
                />
                <Input label="Email"   name="email"   value={form.email}   onChange={handleChange} disabled={!editMode} />
                <Input label="PAN"     name="pan"     value={form.pan}     disabled />
                <Input label="Aadhaar" name="aadhaar" value={form.aadhaar} disabled />
                <Input label="DOB" type="date" name="dob" value={form.dob} onChange={handleChange} disabled={!editMode} />
                <div>
                  <label className="block mb-1">Gender</label>
                  <select
                    name="gender"
                    value={form.gender}
                    onChange={handleChange}
                    disabled={!editMode}
                    className="w-full border rounded-lg p-3"
                  >
                    <option value="">Select</option>
                    <option value="M">Male</option>
                    <option value="F">Female</option>
                    <option value="T">Transgender</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="mb-6">
              <h3 className="font-semibold mb-4">Address Details</h3>
              <div className="grid md:grid-cols-3 gap-4">
                <Input label="Address" name="address" value={form.address} onChange={handleChange} disabled={!editMode} />
                <Input label="City"    name="city"    value={form.city}    onChange={handleChange} disabled={!editMode} />
                <Input label="Pincode" name="pincode" value={form.pincode} onChange={handleChange} disabled={!editMode} />
              </div>
            </div>

            <button
              onClick={handleEkyc}
              disabled={loading}
              className="w-full py-4 bg-blue-600 text-white rounded-xl"
            >
              {loading ? "Processing..." : "Start E-KYC"}
            </button>
          </>
        )}

        {/* Status message */}
        {message && (
          <div className="mt-5 p-4 bg-gray-50 rounded-xl text-center">
            {message}
          </div>
        )}

      </div>
    </div>
  );
}

function Input({ label, ...props }) {
  return (
    <div>
      <label className="block mb-1">{label}</label>
      <input {...props} className="w-full border rounded-lg p-3" />
    </div>
  );
}
